export default "__VITE_ASSET__C0Gg7bXZ__"